<template>
    <div class="contact-form">
        <h2 class="has-text-dark is-size-1 has-text-weight-bold has-text-light ml-2" style="margin-bottom: 0.5rem;">Contáctanos</h2>
        <p class="text-primary is-size-6 has-text-weight-bold has-text-light pb-5 ml-4" style="margin-top: 0.25rem;">Si tienes alguna pregunta o comentario, por favor completa el formulario y nos pondremos en contacto contigo lo antes posible.</p>
        <el-form ref="formRef" @submit.prevent="handleSubmit" :model="form" :rules="rules" label-position="top" class="contact-form__form">
            <el-form-item label="Nombre completo" prop="name">
                <el-input v-model="form.name" placeholder="Ingresa tu nombre completo" />
            </el-form-item>
            <el-form-item label="Correo electrónico" prop="email">
                <el-input v-model="form.email" placeholder="Ingresa tu correo electrónico" />
            </el-form-item>
            <el-form-item label="Teléfono" prop="phone">
                <el-input v-model="form.phone" placeholder="Ingresa tu número de teléfono" />
            </el-form-item>
            <el-form-item label="Estado" prop="state">
                <el-select v-model="form.state" placeholder="Selecciona un estado">
                    <el-option v-for="state in estados" :key="state" :label="state" :value="state" />
                </el-select>
            </el-form-item>
            <el-form-item label="Ciudad" prop="city">
                <el-input v-model="form.city" placeholder="Ingresa tu city" />
            </el-form-item>
            <el-form-item label="Comentario" prop="coment">
                <el-input type="textarea" v-model="form.coment" placeholder="Escribe tu comentario" :rows="4" />
            </el-form-item>
            <el-form-item>
                <el-button type="primary" native-type="submit">Enviar</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script setup>
    import { reactive, ref } from 'vue';
    import apiClient from '@/api/apiClient';
    import { showNotification } from '@/utils/notification';

    const form = reactive({
        name: '',
        email: '',
        phone: '',
        city: '',
        state: '',
        coment: ''
    });

    const estados = [
        'Aguascalientes',
        'Baja California',
        'Baja California Sur',
        'Campeche',
        'Chiapas',
        'Chihuahua',
        'Ciudad de México',
        'Coahuila',
        'Colima',
        'Durango',
        'Estado de México',
        'Guanajuato',
        'Guerrero',
        'Hidalgo',
        'Jalisco',
        'Michoacán',
        'Morelos',
        'Nayarit',
        'Nuevo León',
        'Oaxaca',
        'Puebla',
        'Querétaro',
        'Quintana Roo',
        'San Luis Potosí',
        'Sinaloa',
        'Sonora',
        'Tabasco',
        'Tamaulipas',
        'Tlaxcala',
        'Veracruz',
        'Yucatán',
        'Zacatecas'
    ];

    const formRef = ref(null);

    const rules = {
        name: [{ required: true, message: 'Por favor ingresa tu nombre completo', trigger: 'change' }],
        email: [
            { required: true, message: 'Por favor ingresa tu correo electrónico', trigger: 'change' },
            { type: 'email', message: 'Por favor ingresa un correo válido', trigger: 'change' }
        ],
        phone: [
            { required: true, message: 'Por favor ingresa tu número de teléfono', trigger: 'change' },
            { pattern: /^[0-9]{7,10}$/, message: 'El teléfono debe tener entre 7 y 10 dígitos', trigger: 'change' }
        ],
        state: [{ required: true, message: 'Por favor selecciona un state', trigger: 'change' }],
        city: [{ required: true, message: 'Por favor ingresa tu city', trigger: 'change' }],
        coment: [{ required: true, message: 'Por favor escribe tu coment', trigger: 'change' }]
        };

    const handleSubmit = () => {
        formRef.value.validate(valid => {
            if (valid) {
                apiClient.post('/contact/save', form)
                    .then(response => {
                        console.log('Formulario de contacto enviado', response);
                        showNotification('Gracias por contactarnos','¡Nos pondremos en contacto contigo lo antes posible!', 'success');
                    })
                    .catch(error => {
                        console.log('Error en el formulario de contacto', error);
                        showNotification('Error', (error.response?.data?.msg || error) || 'Error inesperado', 'error');
                    });
            } else {
                return showNotification('Error', 'Por favor completa todos los campos.', 'error');
            }
        });
    };
</script>

<style scoped>
    .contact-form {
        max-width: 600px;
        margin: 0 auto;
        padding: 2.5rem;
        background-color: rgba(255, 255, 255, 0.95);
        border-radius: 12px;
        box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
    }
</style>